import { Component } from '@angular/core';

@Component({
  selector: 'broker-logout-svg',
  templateUrl: './logout-svg.component.svg'
})
export class LogoutSvgComponent {}
